exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".base-input-group{display:flex}.base-input-div{text-align:left}.base-input-group-append{display:flex;align-items:center;color:#495057;font-size:18px;font-weight:400;line-height:1.5;text-align:center;white-space:nowrap;background-color:#eee;border:1px solid #ced4da;padding:10px}.addon-select{min-width:95px}", ""]);

// exports
